import DesktopConfigData from '../mapbox-constants/desktop_config_constants';
import {STYLE_DEFAULT_URL} from '../mapbox-constants/mapbox_constants';

const mapState = {
  style: STYLE_DEFAULT_URL,
  doubleClickZoom: false,
  center: DesktopConfigData.MAP_INITAL_CENTER,
  minZoom: DesktopConfigData.ZOOM_MIN_SECTIONS,
  maxZoom: DesktopConfigData.ZOOM_MAX_SEATS,
};

export default mapState;
